/**
 * ProfileBar — Compact user profile display shown after verification
 * Displays between StepIndicator and content area during booking steps
 */
import type { JSX } from 'preact'

interface ProfileBarProps {
  firstName: string
  lastName: string
  email: string
  homeClubName: string
}

export function ProfileBar({ firstName, lastName, email, homeClubName }: ProfileBarProps): JSX.Element {
  const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase()

  return (
    <div className="bw2-profile-bar">
      <div className="bw2-profile-bar__avatar">{initials}</div>
      <div className="bw2-profile-bar__info">
        <span className="bw2-profile-bar__name">{firstName} {lastName}</span>
        <span className="bw2-profile-bar__detail">{email}</span>
      </div>
      {homeClubName && (
        <div className="bw2-profile-bar__club">
          <span className="bw2-profile-bar__club-label">Home Club</span>
          <span className="bw2-profile-bar__club-name">{homeClubName}</span>
        </div>
      )}
    </div>
  )
}
